export default __webpack_public_path__ + "img/discode.7d7278a08ba3b8d5cb249f8fcbba13f5.png";